import { createAction } from 'typesafe-actions';

export const changeGeoTitleAction = createAction('filters/geoTitleChanged')<{
  id: number;
  title: string;
  color?: string;
}>();

export const setGeoTitleAction = createAction('filters/setGeoTitle')<{ id: number; title: string; color?: string }[]>();
